<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1eH0Tq/tc-custom/9781250015945.jpg?1737775936350" alt="This image is the cover for the book Dandy Gilver and an Unsuitable Day for a Murder, Dandy Gilver Murder Mystery Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dandy Gilver and an Unsuitable Day for a Murder, Dandy Gilver Murder Mystery Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"Guaranteed to appeal to those who never got over the death of Dorothy L. Sayers."--<i>Financial Times </i>(UK) </b><br/><br/>Aristocratic and delightfully witty amateur sleuth Dandy Gilver was greeted with boisterous cheers from readers and reviewers alike in Catriona McPherson's previous outing,<i> Dandy Gilver and the Proper Treatment of Bloodstains, </i>which <i>The Boston Globe </i>named one of the best crime novels of 2011. In this new book in this charming and funny series, Dandy is caught between two feuding families who run rival department stores.<br/><br/>Dandy's services are needed when the heiress to one of the stores goes missing. As Dandy starts to unravel long-hidden family secrets, she begins to discover disturbing connections, and it's not long before danger abounds. <br/><br/>"With witty dialogue and low-key humor, McPherson's series is a great choice for Jacqueline Winspear, Carola Dunn, and Amy Patricia Meade fans. A strong traditional offering with sly humor, a love of dogs, and not too much violence. A real contender for the Agathas!"(<i>Library Journal, </i>starred review), <i>Dandy Gilver and an Unsuitable Day for a Murder </i>is one mystery not to be missed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Catriona McPherson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5379fe71